import { Dropdown } from 'react-bootstrap';
import * as React from 'react';
import { Action } from 'moduleBase/modules/menu-balance/components/Action';
import { MenuItemList } from 'moduleBase/modules/menu-balance/components/MenuItemList';
import { Wait } from 'moduleBase/modules/menu-balance/components/Wait';
import { Frozen } from 'moduleBase/modules/menu-balance/components/Frozen';

var DropdownMenu = function DropdownMenu() {
  return /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "dropdown-flat-menu dropdown-flat-menu_center"
  }, /*#__PURE__*/React.createElement(Action, null), /*#__PURE__*/React.createElement(MenuItemList, null), /*#__PURE__*/React.createElement(Wait, null), /*#__PURE__*/React.createElement(Frozen, null));
};

export { DropdownMenu };